<!--
 * @Descripttion: 
 * @Author: zhongbin.chen
 * @Date: 2021-12-10 10:27:15
-->
<template>
  <div class="agreement">
    <span class="titleName" @click="visible = true">{{ $t("login.termsService") }}</span>
    <el-dialog top="30px" title v-model="visible" width="832px">
      <div class="agreementInfo">
        <div class="contentBox">
          <span class="closeBtn" @click="visible = false"><i class="el-icon-close" /></span>
          <p class="text1 center" style="margin-bottom: 30px">{{$t('agreement.text1')}}</p>
          <p class="text2" style="margin-bottom: 10px">{{$t('agreement.text2')}}</p>
          <li>{{$t('agreement.text3')}}</li>
          <li>{{$t('agreement.text4')}}</li>
          <li style="margin-bottom: 20px">{{$t('agreement.text5')}}</li>

          <p
            style="margin-bottom: 20px"
          >{{$t('agreement.text6')}}</p>

          <p style="margin-bottom: 20px">{{$t('agreement.text7')}}</p>

          <p
            style="margin-bottom: 20px"
          >{{$t('agreement.text8')}}</p>

          <p>{{$t('agreement.text9')}}</p>
          <p>{{$t('agreement.text10')}}</p>
          <p>{{$t('agreement.text11')}}</p>
          <p>{{$t('agreement.text12')}}</p>
          <p style="margin-bottom: 20px">{{$t('agreement.text13')}}</p>

          <p>{{$t('agreement.text14')}}</p>
          <p>{{$t('agreement.text15')}}</p>
          <p>{{$t('agreement.text16')}}</p>
          <p>{{$t('agreement.text17')}}</p>
          <p style="margin-bottom: 20px">{{$t('agreement.text18')}}</p>

          <p>{{$t('agreement.text19')}}</p>
          <p>{{$t('agreement.text20')}}</p>
          <p>{{$t('agreement.text21')}}</p>
          <p style="margin-bottom: 20px">{{$t('agreement.text22')}}</p>

          <p>{{$t('agreement.text23')}}</p>
          <p>{{$t('agreement.text24')}}</p>
          <p>{{$t('agreement.text25')}}</p>
          <p>{{$t('agreement.text26')}}</p>
          <p>{{$t('agreement.text27')}}</p>
          <p>{{$t('agreement.text28')}}</p>
          <p>{{$t('agreement.text29')}}</p>
          <p>{{$t('agreement.text30')}}</p>
          <p>{{$t('agreement.text31')}}</p>
          <p style="margin-bottom: 20px">{{$t('agreement.text32')}}</p>

          <p
            style="margin-bottom: 20px"
          >{{$t('agreement.text33')}}</p>

          <p style="margin-bottom: 20px">{{$t('agreement.text34')}}</p>

          <p
            style="margin-bottom: 20px"
          >{{$t('agreement.text35')}}</p>

          <p>{{$t('agreement.text36')}}</p>
          <p>{{$t('agreement.text37')}}</p>
          <p>{{$t('agreement.text38')}}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  watch,
  ref,
  nextTick,
  toRefs
} from "vue";
export default {
  components: {},
  setup() {
    const state = reactive({
      visible: false
    });
    onMounted(() => {});
    return {
      ...toRefs(state)
    };
  }
};
</script>

<style lang="scss">
.agreement {
  display: inline-block;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .titleName {
    color: #40a9ff;
    cursor: pointer;
  }
  .agreementInfo {
    height: 800px;
    overflow-y: auto;
  }
  .contentBox {
    padding: 50px 34px;
    text-align: left;
    .center {
      text-align: center;
    }
    p,
    li {
      line-height: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      margin: 0 0 4px;
      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .text1 {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000;
    }
    .text2 {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #000;
    }
    .closeBtn {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }
  }
}
</style>
